exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top_sec{padding: 20px;}\nh4{white-space: nowrap; margin-top: 13px; line-height: 30px;}\na.view_icon{font-size: 22px;}\n.badge{font-size: 11px; vertical-align: top;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/profile/feedback-sent-to/feedback-sent-to.component.css
// module id = ../../../../../src/app/admin/profile/feedback-sent-to/feedback-sent-to.component.css
// module chunks = 39